import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import {clearLoginInfo} from '@/utils/store'

const Login = () => import(/* webpackChunkName: "zypc" */ '@/views/Login')
const Main = () => import(/* webpackChunkName: "zypc" */ '@/views/Main')
const Evaluation = () => import(/* webpackChunkName: "zypc" */ '@/views/Evaluation')
const EvaluationEnter = () => import(/* webpackChunkName: "zypc" */ '@/views/EvaluationEnter.vue')
const EvaluationReportWrapper = () => import(/* webpackChunkName: "zypc" */ '@/views/EvaluationReportWrapper.vue')
const EvaluationReportIndex = () => import(/* webpackChunkName: "zypc" */ '@/views/EvaluationReportIndex.vue')
const EvaluationReportPage = () => import(/* webpackChunkName: "zypc" */ '@/views/EvaluationReportPage.vue')
const EvaluationReportBackCover = () => import(/* webpackChunkName: "zypc" */ '@/views/EvaluationReportBackCover.vue')
const Filter = () => import(/* webpackChunkName: "zypc" */ '@/views/Filter.vue')

const routes = [
  {
    path: '/login',
    component: Login,
    name: 'login'
  },
  {
    path: '/main',
    component: Main,
    children: [
      {
        path: '',
        name: 'evaluation',
        component: Evaluation
      },
      {
        path: 'evaluationEnter',
        name: 'evaluationEnter',
        component: EvaluationEnter
      },
      {
        path: 'filter',
        name: 'filter',
        component: Filter
      }
    ]
  },
  {
    path: '/evaluationReport',
    component: EvaluationReportWrapper,
    meta: {
      contentFullWidth: true,
      requiresAuth: true
    },
    children: [
      {
        path: '',
        component: EvaluationReportIndex
      },
      {
        path: 'page/:index',
        component: EvaluationReportPage
      },
      {
        path: 'backCover',
        component: EvaluationReportBackCover
      }
    ]
  },
  {
    path: '*',
    component: Login
  }
]

Vue.use(VueRouter)
const router = new VueRouter({
  mode: 'history',
  routes: routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})
router.beforeEach ((to, from, next) => {
  let isLogin = store.getters.isLogin
  if (!isLogin && to.name !== 'login') {
    clearLoginInfo()
    next({ name: 'login' })
  }
  next()
})

export default router
